import { startOfDay } from 'date-fns';
import { get } from 'lodash-es';
import { parseDate } from '@zg-rentals/formatters';
import { FIELD_IDS } from './wizard';
import type { Answers, UserStatus } from '../models/rental-application';
import { getMaxDocumentsPerIncome } from './form';
import {
  getIsBackgroundReportExpirationInFuture,
  getIsCreditReportExpirationInFuture,
  getIsPaymentValid,
} from '../utils/user-statuses';

export function getIsMoveInDateValid({ answers }: { answers: Answers }) {
  const answer = get(answers, FIELD_IDS.MOVE_IN_DATE);
  if (!answer) return false;

  const parsedDate = parseDate(answer);
  if (!parsedDate) return false;

  // Compare start of day to ensure today's date is valid
  const today = startOfDay(new Date());
  const moveInDay = startOfDay(parsedDate);

  return moveInDay >= today;
}

export function getIsIncomeDocumentsValid({ answers, index }: { answers: Answers; index?: number }) {
  if (typeof index !== 'number') {
    return true;
  }
  const documents = get(answers, FIELD_IDS.CURRENT_INCOMES_DOCUMENTS.replace('[]', `[${index}]`));

  return !documents || documents.length <= getMaxDocumentsPerIncome(true);
}

export function getIsPaymentAndReportsStepValid({ userStatuses }: { userStatuses: Array<UserStatus> }) {
  const isPaymentValid = getIsPaymentValid(userStatuses);

  if (!isPaymentValid) {
    return true;
  }

  return getIsCreditReportExpirationInFuture(userStatuses) && getIsBackgroundReportExpirationInFuture(userStatuses);
}
